import { Card, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import "../index.css";
import { AppBarChart } from "./charts/BarChart";
import { Loader } from "./Loader";
import { useBarChart } from "../hooks/useBarChart";
import { detractors, promoters } from "../constants/constants";
const ModelNPSBarChart = ({ data }) => {
  const { graphData, loading, setGraphData, setLoading, setYAxis, yAxis } =
    useBarChart();

  function calculateMonthlyNPS(responses) {
    const modelNPS = {};
    for (const response of responses) {
      const model = response.model;
      if (response.feedback) {
        if (!modelNPS[model]) {
          modelNPS[model] = {
            promoters: 0,
            detractors: 0,
            total: 0,
          };
        }

        if (promoters.includes(response.feedback)) {
          modelNPS[model].promoters++;
        } else if (detractors.includes(response.feedback)) {
          modelNPS[model].detractors++;
        }
        modelNPS[model].total++;
      }
    }
    let modelWiseNPSArr = [];
    for (const model in modelNPS) {
      const { promoters, detractors, total } = modelNPS[model];
      let nps = ((promoters - detractors) / total) * 100;
      nps = nps.toFixed(0);
      modelWiseNPSArr.push({ model, nps });
    }

    const values = modelWiseNPSArr.map((item) => Number(item.nps));
    setYAxis({ min: Math.min(...values), max: Math.max(...values) });
    return modelWiseNPSArr;
  }

  useEffect(() => {
    if (data) {
      setGraphData(calculateMonthlyNPS(data));
      setLoading(false);
    }
  }, [data]);

  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: 3,
        width: "100%",
        height: "400px",
        p: "15px",
        background: "#1d2637",
        color: "white",
        borderRadius: "12px",
        fontFamily: "Montserrat, serif",
      }}
    >
      <Typography
        sx={{ fontFamily: "Montserrat, serif !important" }}
        variant="overline"
        gutterBottom
      >
        Model-wise NPS
      </Typography>

      {loading ? (
        <Loader />
      ) : (
        <AppBarChart
          data={graphData}
          xAxisKey={"model"}
          xLabel={"Model Name"}
          yLabel={"NPS Score"}
          dataKey={"nps"}
          yMax={yAxis.max}
          yMin={yAxis.min}
          fill="yellow"
          yMinOffset={0}
          yMaxOffset={0}
        />
      )}
    </Card>
  );
};

export default ModelNPSBarChart;
